import { render, staticRenderFns } from "./PartnersResourceEdit.vue?vue&type=template&id=0af3d730"
import script from "./PartnersResourceEdit.vue?vue&type=script&lang=js"
export * from "./PartnersResourceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports